// H5 router assembly. Route tables live next to their owning module in
// ./modules/ so that adding a page never grows a shared mega-file.
import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";

import { contentRoutes } from "./modules/content";
import { financeRoutes } from "./modules/finance";
import { hotelRoutes } from "./modules/hotel";
import { identityRoutes } from "./modules/identity";
import { orderRoutes } from "./modules/order";
import { referralRoutes } from "./modules/referral";
import { supportRoutes } from "./modules/support";
import { systemRoutes } from "./modules/system";

// Order matters only for matching precedence; paths are distinct.
const routes: RouteRecordRaw[] = [
  ...identityRoutes,
  ...contentRoutes,
  ...hotelRoutes,
  ...orderRoutes,
  ...financeRoutes,
  ...referralRoutes,
  ...supportRoutes,
  ...systemRoutes,
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
